<template>
  <v-container fluid slot="pdf-content">
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <v-card class="mt-3" v-for="(b, index) in bookings" :key="index" style="page-break-after: always">
            <div v-if="!b.isEntry">
              <v-card-title>{{b.customer.name}} - {{b.startDate | moment('DD/MM/YYYY HH:mm')}}<span v-if="b.history.length === 0"> - New Customer</span>
                <p class="display-1" v-if="b.isPayingCash">THIS IS A CASH PAYMENT - ENSURE CASH IS COLLECTED</p>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <p>Service: {{b.valet}}</p>
                    <!--                                    <p>Description: {{b.valetDescription}}</p>-->
                    <p v-if="b.price && !b.isParent">Price: £{{parseFloat(b.price).toFixed(2)}}</p>
                    <p v-if="b.isParent && b.selectedServices && b.selectedServices.length > 0">Price: £{{b.selectedServices[0].unitPrice}}</p>
                    <!--                                    <p v-if="b.totalCharged">Paid: £{{parseFloat(b.totalCharged).toFixed(2)}}</p>-->
                    <p>Phone: {{b.customer.phone}}</p>
                    <p>Mobile: {{b.customer.mobile}}</p>
                    <p>Booking Made By: {{b.bookingMadeBy}}</p>
                  </v-col>
                  <v-col>
                    <p>Email: {{b.customer.email}}</p>
                    <p>Address: <br />
                      {{b.customer.address1}}
                      <br />
                      {{b.customer.address2}}
                      <br />
                      {{b.customer.city}}
                      <br />
                      {{b.customer.county}}
                      <br />
                      {{b.customer.postcode}}
                    </p>
                    <div v-if="b.customer.additionalAddress">
                      <p>Valet Location Address: <br />
                        {{b.customer.addAddress1}}
                        <br />
                        {{b.customer.addAddress2}}
                        <br />
                        {{b.customer.addCity}}
                        <br />
                        {{b.customer.addCounty}}
                        <br />
                        <span>{{b.customer.addPostCode}}</span>
                      </p>
                    </div>
                    <div v-if="b.history.length > 0">
                      <h5 class="display-1">History</h5>
                      <p v-for="(h, i) in b.history" :key="i">{{h.name}} - {{h.date | moment('DD/MM/YYYY')}}</p>
                    </div>
                  </v-col>
                </v-row>
                <v-divider />
                <v-row>
                  <v-col>
                    <div v-if="b.vehicles">
                      <div v-for="(v, i) of b.vehicles" :key="i">
                        <p>Car: {{v.make}} - {{v.model}}</p>
                        <p>Registration: {{v.registration}}</p>
                        <p>Mileage: {{v.mileage}}</p>
                        <p>Colour: {{v.colour}}</p>
                        <p>Usage: {{v.usage}}</p>
                      </div>
                      <p>Description: {{b.description}}</p>
                      <p>Notes: {{b.notes}}</p>
                      <p>Up-sell Opportunities: {{b.upsellOptions}}</p>
                    </div>
                    <div v-if="!b.vehicles">
                      <p>Car: {{b.customer.make}} - {{b.customer.model}}</p>
                      <p>Registration: {{b.customer.registration}}</p>
                      <p>Mileage: {{b.customer.mileage}}</p>
                      <p>Description: {{b.description}}</p>
                      <p>Notes: {{b.notes}}</p>
                      <p>Up-sell Opportunities: {{b.upsellOptions}}</p>
                    </div>
                  </v-col>
                  <v-col>
                    <p>Start: {{b.startDate | moment('DD/MM/YYYY HH:mm')}}</p>
                    <p>End: {{b.endDate | moment('DD/MM/YYYY HH:mm')}}</p>
                    <p>Reason for Valet: {{b.purpose}}</p>
                    <p>Power: {{b.hasPower}}</p>
                    <p>Water: {{b.hasWater}}</p>
                    <p>Can be re-arranged: {{b.canBeChanged}}</p>
                    <p>Invoice Number: {{b.xeroInvoiceNumber}}</p>
                    <p>Technician: {{b.xeroValetTrackingId}}</p>
                    <p>Commission Period: {{b.xeroCommissionTrackingId}}</p>
                    <p>Commission Basis: {{b.xeroAccountName}}</p>
                    <p v-if="b.xeroAccountName !== 'Sales (30%)'">Commission Reason: {{ b.xeroAccountCodeReason }}</p>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
            <div v-if="b.isEntry">
              <v-card-title>{{b.customer.name}}</v-card-title>
              <v-card-text>
                <h4>NO BOOKING - {{b.customer.name}}</h4>
                <p>Start: {{b.startDate | moment('DD/MM/YYYY HH:mm')}}</p>
                <p>End: {{b.endDate | moment('DD/MM/YYYY HH:mm')}}</p>
              </v-card-text>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {BookingsHttp} from "@/http/BookingsHttp";

export default {
  name: "Contracts",
  async mounted() {
    this.bookings = await BookingsHttp.getBookingsByPsk(this.$route.params.id).then(result => result.data);
  },
  data() {
    return {
      bookings: []
    }
  }
}
</script>
